import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "deviationsubmitpopup" */
        '../../redux/ModuleLoadable'
      )
  )
);

const LoadableWriterPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "postpopup" */
        './index'
      )
  )
);

interface Props {
  deviation: PapiDeviation;
  requestClose: () => void;
}

const LazyWriterPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyWriterPopup">
    <Suspense fallback={<LoadingIndicator view={'llama'} usePortal />}>
      <LoadableRedux />
      <LoadableWriterPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyWriterPopup.displayName = 'LazyWriterPopup';

export default LazyWriterPopup;
